import { render, staticRenderFns } from "./Cheeers3Icon.vue?vue&type=template&id=1ff21e4a&scoped=true&"
import script from "./Cheeers3Icon.vue?vue&type=script&lang=ts&"
export * from "./Cheeers3Icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff21e4a",
  null
  
)

export default component.exports